import React from "react";
import CTA from "./CTA";
import Copyright from "./Copyright";
const Footer = () => {
  return (
    <>
      <CTA />
      <Copyright />
    </>
  );
};

export default Footer;
